export default __webpack_public_path__ + "static/media/social.0b3dfcf1.webp";